import React from "react";
import { useClients } from "../../hooks/useClients";

export function ClientDropdown({
  value,
  setValue,
  error,
  placeholder,
  kind,
}: {
  value: string;
  setValue: any;
  error: string;
  placeholder?: string;
  kind: "buyer" | "seller" | "agent" | "lender" | "titleAbstractor" | "surveyor";
}) {
  const clients = useClients();

  const filtered = React.useMemo(
    () => (clients || []).filter((c) => c.kind === kind),
    [clients, kind]
  );

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = filtered.find((c) => c.id === e.target.value);
    if (selected) setValue(selected);
  };

  return (
    <div className="p-field" style={{ marginBottom: 18 }}>
      <select
        className="p-select"
        value={value || ""}
        onChange={handleChange}
      >
        <option value="">{placeholder || "— Select —"}</option>
        {filtered.map((c) => (
          <option key={c.id} value={c.id}>{c.name}</option>
        ))}
      </select>
      {error && <div style={{ fontSize: 12, color: "var(--maroon)" }}>{error}</div>}
    </div>
  );
}
